export default __webpack_public_path__ + "static/media/pic22.c4edca02.jpg";